import { Edit } from './Edit';
import { View } from './View';
import circleMenuSVG from '@plone/volto/icons/circle-menu.svg';

export const iconBlock = {
  id: '__iskra-icon',
  title: 'Iskra icon',
  icon: circleMenuSVG,
  group: 'common',
  view: View,
  edit: Edit,
  restricted: false,
  mostUsed: true,
  sidebarTab: 1,
  security: {
    addPermission: [],
    view: [],
  },
};
